import { Box, styled } from "@mui/material";
import { Button, IconButton } from "@pmag/ui-components";

export const Root = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",

    [theme.breakpoints.down("md")]: {
        flexDirection: "column",
    },
}));

export const BoxContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(7),

    [theme.breakpoints.down("md")]: {
        gap: theme.spacing(4),
    },
}));

export const BoxImage = styled(Box)(({ theme }) => ({
    flexShrink: "0",
    width: "60px",
    aspectRatio: "1.5/1",

    [theme.breakpoints.down("md")]: {
        width: "90px",
    },
}));

export const ModelImage = styled("img")(() => ({
    width: "100%",
    height: "100%",
    objectFit: "contain",
}));

export const BoxContent = styled(Box)(({ theme }) => ({
    width: "100%",
    display: "grid",
    columns: 1,
    rowGap: theme.spacing(1),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
        display: "flex",
        columnGap: theme.spacing(4),
    },
}));

export const BoxMain = styled(Box)(() => ({
    width: "100%",
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
    alignSelf: "center",

    [theme.breakpoints.up("sm")]: {
        display: "none",
    },
}));

export const SeparatorRightContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    height: 56,
    alignItems: "center",
    position: "relative",
    marginRight: theme.spacing(4),

    [theme.breakpoints.down("md")]: {
        display: "none",
    },
}));

export const SeparatorDownContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    position: "relative",
    height: 8,
    width: "100%",
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),

    [theme.breakpoints.up("sm")]: {
        display: "none",
    },
}));

export const SeparatorVertical = styled(Box)(({ theme }) => ({
    display: "flex",
    height: "100%",
    width: 1,
    backgroundColor: theme.palette.core.grey._40,
    position: "absolute",
    left: "50%",
}));

export const SeparatorHorizontal = styled(Box)(({ theme }) => ({
    display: "flex",
    width: "100%",
    height: 1,
    backgroundColor: theme.palette.core.grey._30,
    position: "absolute",
    top: "50%",
}));

export const ArrowRightBox = styled(Box)(({ theme }) => ({
    borderTop: `1px solid ${theme.palette.core.grey._40}`,
    borderRight: `1px solid ${theme.palette.core.grey._40}`,
    backgroundColor: "#FFFFFF",
    width: 10,
    height: 10,
    transform: "rotate(45deg) translate(2px, 1px)",
    transformOrigin: "center",
}));

export const ArrowDownBox = styled(Box)(({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.core.grey._30}`,
    borderRight: `1px solid ${theme.palette.core.grey._30}`,
    marginLeft: 40,
    backgroundColor: theme.palette.core.white,
    width: 10,
    height: 10,
    transform: "rotate(45deg) translate(1px, 0px)",
    transformOrigin: "center",
}));

export const BoxButtons = styled(Box)(({ theme }) => ({
    flexShrink: "0",
    display: "flex",
    flexWrap: "wrap",
    rowGap: theme.spacing(1),
    columnGap: theme.spacing(3),
    alignItems: "center",

    [theme.breakpoints.down("md")]: {
        display: "none",
    },
}));

export const SelectVehicleButton = styled(Button)(() => ({
    padding: 0,
}));
